/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import {
  Container,
  Dimmer,
  Grid,
  Loader,
  Segment,
} from 'semantic-ui-react';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isNumber from '../../utils/numbers/isNumber';
import NavBar from '../../components/NavBar';
import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import AddressSettingActivities from '../../components/AddressSettingActivities';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class Activities extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const search = query.search || '';
    return {
      data: [],
      loading: true,
      query,
      search,
    };
  }
  constructor(props) {
    super(props);
    const state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    this.state = state;
  }
  componentDidMount() {
    const { query } = this.props.location;
    this.fetchActivities(query);
  }
  componentWillReceiveProps(nextProps) {
    const { query } = nextProps.location;
    const state = Activities.getPropsToState(nextProps);
    if (this.state.data) {
      state.data = this.state.data;
    }
    this.setState({ ...state }, () => {
      if (!this.state.data) {
        this.fetchActivities(query);
      }
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchActivities(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    const queryStr = qs.stringify(query);
    if (queryStr) {
      queryString = `?${queryStr}`;
    }
    try {
      res = await store.dispatch(fetchM(`/address_settings/activities/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    } else {
      const data = await res.json();
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        count,
        limit,
        offset,
        data,
      });
      await this.setLoading(false);
    }
  }
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    } else {
      this.setState({ search: '' });
    }
  }
  handleOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  async replaceQuery(query, resetPage = false) {
    await this.setLoading(true);
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) queryNew.page = 1;
    await this.fetchActivities(query);
    store.dispatch(replace(`/settings/address_settings/activities/?${encodeSearch(queryNew)}`));
    await this.setLoading(false);
  }
  sortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'company_address_setting_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'company_address_setting_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  render() {
    const { data } = this.state;
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Address Setting Activity Logs')}
        />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16}>
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                placeholder={t('Search')}
                setAdvanceFilter={() => {}}
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              />
            </Grid.Column>
            <Grid.Column width={16} textAlign="center">
              <br />
              <Segment>
                <AddressSettingActivities
                  data={data || []}
                  hasAccess={this.hasAccess()}
                  loading={this.state.loading}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
export default withTranslation(namespaces)(connect(Activities.mapStateToProps)(Activities));



// WEBPACK FOOTER //
// ./src/containers/SystemSettings/AddressSettingActivities.jsx